const flexsdkSubscriptionButtons = {
	renew: 'Forny',
	upgrade: 'Opgrader',
	addOrder: 'Tilføj ordre til bon',
	changePeriod: 'Ændre periode',
	terminateRefund: 'Opsig/refunder'
};

export default flexsdkSubscriptionButtons;
